<template>
        <div>

                <div class="container is-fluid box" style="z-index: 1;">
                        <div class="level">
                                <div class="level-left" style="width: 320px;">
                                        <div class="control">
                                                <input class="box-info-search input" style="width: 320px;" type="text"  v-model="searchText"
                                                       placeholder="Search TLC OR Device UID">
                                        </div>
                                </div>
                        </div>
                    <div class="columns"  style="justify-content: right;">
                        <div class="column has-text-right">
                            <div class="tooltip"><font-awesome-icon class="is-size-5 is-warning" icon="info"/>
                                <div class="tooltiptext">
                                    <ul style="list-style: disc outside">
                                        <li style="margin-left: 20px">
                                            <p style="margin-bottom: 10px">Where EFF application is used from iPad devices;</p>
                                        </li>
                                        <li style="margin-left: 20px">
                                            <p style="margin-bottom: 10px">Device UID, TLC,  OS version, App version, Last position, Battery Level etc</p>
                                        </li>
                                        <li style="margin-left: 20px">
                                            <p style="margin-bottom: 10px">Last login and first login time of Eff Application</p>
                                        </li>
                                        <li style="margin-left: 20px">
                                            <p style="margin-bottom: 10px">Request and Download times of Occ, Logs, Inputs packages</p>
                                        </li>
                                        <li style="margin-left: 20px">
                                            <p style="margin-bottom: 10px">Device Inspector details navigate to get Ipad device statistics</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="">
                        <div class="user-table">
                                <table class="table is-striped is-fullwidth is-bordered animate__animated animate__slideInUp animate__faster fontsizesmall">
                                        <thead>
                                        <tr>

                                                <th :class="{ sorted: sort === 'id' }" @click="sortBy('id')">ID</th>
                                                <th :class="{ sorted: sort === 'devicE_UUID' }" @click="sortBy('devicE_UUID')">IPAD Device UID</th>
                                                <th :class="{ sorted: sort === 'tlcLastLoggedIn' }" @click="sortBy('tlcLastLoggedIn')" title="TLC Last Logged In">TLC Logged</th>
                                                <th :class="{ sorted: sort === 'firstLoginTime' }" @click="sortBy('firstLoginTime')">First Login Time</th>
                                                <th :class="{ sorted: sort === 'lastLoginTime' }" @click="sortBy('lastLoginTime')">Last Login Time</th>

                                                <th :class="{ sorted: sort === 'totaL_TLC' }" @click="sortBy('totaL_TLC')">Total Log TLC</th>
                                                <th :class="{ sorted: sort === 'lastHeartBeat_DT' }" @click="sortBy('lastHeartBeat_DT')">Last Heartbeat</th>

                                                <th :class="{ sorted: sort === 'osVersion' }" @click="sortBy('osVersion')">OS Version</th>
                                                <th :class="{ sorted: sort === 'appVersion' }" @click="sortBy('appVersion')">App Version</th>

                                                <th title="Last Known OCC Version" :class="{ sorted: sort === 'lastKnownOcc_LVC_DT' }" @click="sortBy('lastKnownOcc_LVC_DT')">OCC Version</th>
                                                <th :class="{ sorted: sort === 'utC_DIFF' }" @click="sortBy('utC_DIFF')">Utc Diff</th>
                                                <th :class="{ sorted: sort === 'lastLatitude' }" @click="sortBy('lastLatitude')">Last Latitude</th>
                                                <th :class="{ sorted: sort === 'lastLongitude' }" @click="sortBy('lastLongitude')">Last Longitude</th>
                                                <th :class="{ sorted: sort === 'batteryLevel' }" @click="sortBy('batteryLevel')">BatteryLevel</th>

                                                <th :class="{ sorted: sort === 'btO_LVC' }" @click="sortBy('btO_LVC')">BTO LVC</th>
                                                <th :class="{ sorted: sort === 'aL_LVC' }" @click="sortBy('aL_LVC')">AL LVC</th>

                                                <th :class="{ sorted: sort === 'btoSignedBy'}" @click="sortBy('btoSignedBy')" title="Last BTO SignedBy">BTO SignedBy</th>
                                                <th :class="{ sorted: sort === 'alSignedBy'}" @click="sortBy('alSignedBy')" title="Last AL SignedBy">AL SignedBy</th>

                                                <th :class="{ sorted: sort === 'toT_FILE_RECEIVED' }" @click="sortBy('toT_FILE_RECEIVED')">Total File Received</th>
                                                <th :class="{ sorted: sort === 'toT_FILE_WAITING' }" @click="sortBy('toT_FILE_WAITING')">Total File Waiting</th>
                                                <th :class="{ sorted: sort === 'lasT_REQUEST' }" @click="sortBy('lasT_REQUEST')">Last Request</th>
                                                <th :class="{ sorted: sort === 'lasT_DOWNLOAD' }" @click="sortBy('lasT_DOWNLOAD')">Last Download</th>

                                                <th>Device Inspector</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="ipaddevice in this.paginate" :key="ipaddevice.id">
<!--                                        <tr v-for="ipaddevice in this.searchInspectorViewListSorted" :key="ipaddevice.id">-->
                                                <td>{{ipaddevice.id}}</td>
                                                <td>{{ipaddevice.devicE_UUID}}</td>
                                                <td>{{ipaddevice.tlcLastLoggedIn}}</td>
<!--                                            <td>{{ipaddevice.firstLoginTime | longFormatFromDT}}</td>                       -->
<!--                                            <td>{{ipaddevice.lastLoginTime | longFormatFromDT}}</td>                        -->
                                                <td>{{ipaddevice.firstLoginTime | longFormatFromDT}}</td>
                                                <td>{{ipaddevice.lastLoginTime | longFormatFromDT}}</td>
                                                <td>{{ipaddevice.totaL_TLC}}</td>

                                                <td>{{ipaddevice.lastHeartBeat_DT | longFormatFromDT}}</td>
                                                <td>{{ipaddevice.osVersion}}</td>
                                                <td>{{ipaddevice.appVersion}}</td>

                                                <td>{{ipaddevice.lastKnownOcc_LVC_DT}}</td>
                                                <td>{{ipaddevice.utC_DIFF}}</td>
                                                <td>{{ipaddevice.lastLatitude|formatFloatValue}}</td>

                                                <td>{{ipaddevice.lastLongitude |formatFloatValue}}</td>
                                                <td><progress class="progress progressfix" :value="ipaddevice.batteryLevel" max="100"></progress>
                                                        <label>{{ipaddevice.batteryLevel}}%</label></td>
                                                <td>{{ipaddevice.btO_LVC}}</td>
                                                <td>{{ipaddevice.aL_LVC}}</td>

                                                <td>{{ipaddevice.btoSignedBy}}</td>
                                                <td>{{ipaddevice.alSignedBy}}</td>

                                                <td>{{ipaddevice.toT_FILE_RECEIVED}}</td>
                                                <td>{{ipaddevice.toT_FILE_WAITING}}</td>
                                                <td>{{ipaddevice.lasT_REQUEST}}</td>
                                                <td>{{ipaddevice.lasT_DOWNLOAD}}</td>

                                                <td>
                                                        <button title="Edit" class="button is-small is-light is-info" @click="goToEFBDeviceDetails(ipaddevice.devicE_UUID,ipaddevice)">
                                                                <font-awesome-icon icon="edit"/>
                                                                Details
                                                        </button>
                                                </td>
                                        </tr>
                                        </tbody>
                                </table>
                        </div>
                </div>


                <br><br><br><br>
                <div class="">
                        <div class="level">
                                <nav class="pagination" role="navigation" aria-label="pagination">
                                        <ul class="pagination-list">
                                                <li v-if="pageNavigationInfo.hasFirstPageNavigation">
                                                        <div @click="setPage(1)" class="pagination-link">
                                                                <a href="#">« First</a>
                                                        </div>
                                                </li>
                                                <li v-for="index in pageNavigationInfo.pageCount" :key="index">
                                                        <div @click="setPage(pageNavigationInfo.start + index)" class="pagination-link">
                                                                <a href="#" :class="[currentPage === pageNavigationInfo.start + index ? 'current':'']" >{{ pageNavigationInfo.start + index }}</a>
                                                                <!--                                :class="[currentPage === pageNavigationInfo.start + index?'current':'']-->
                                                                <!--                                :class="{current: currentPage === pageNavigationInfo.start + index }"-->
                                                                <!--                                :class="[post.iS_DELETED == 1 && ShowDeletedFlights == true? 'strikeout': '', (post.iS_DELETED == 1 && ShowDeletedFlights == false) ? 'hideDeletedFlight':'']">-->
                                                        </div>
                                                </li>
                                                <li v-if="pageNavigationInfo.hasLastPageNavigation">
                                                        <div @click="setPage(pageNavigationInfo.total)" class="pagination-link">
                                                                <a href="#">Last »</a>
                                                        </div>
                                                </li>
                                        </ul>
                                </nav>
                        </div>
                </div>

        </div>

</template>

<script>
    import {mapState, mapActions} from "vuex";
    import {loadingMixin} from "../../utils/mixins";
    import LoadingButton from "../../components/ui/LoadingButton";

    export default
    {
        name: "Efb",
        mixins: [loadingMixin],
        components: {
            // eslint-disable-next-line vue/no-unused-components
            LoadingButton,
        },

        data()
        {
            return {
                    pageDumpinpectorviewlist : [],

                    isActiveUserModal: false,
                    searchText:"",

                    sort: 'id',
                    sortDir:'asc',

                    pageRange: 3,
                    currentPage: 1,
                    itemsPerPage: 150,
                    resultCount: 0,
                    pageNavigationInfo: {},
            }
        },

        async created() {
                /// this.TrygetUsers();
                await this.Getinspectorviewlist();

                this.currentPage = 1;
                this.buildPageNavigationInfo();
        },

        methods: {
                ...mapActions("efb",["Getinspectorviewlist","GetdeviceslistByuuid","GetheartbeatsignalsByuuid"]),

                goToEFBDeviceDetails(devicE_UUID,selectedIpadDevice)
                {
                        this.$router.push({name: 'EFBDevices', params: {device_uuid: devicE_UUID, Device: selectedIpadDevice}});
                },

                sortBy: function(s) {
                        if (s === this.sort) {
                                this.sortDir = (this.sortDir === 'asc') ? 'desc' : 'asc';
                        } else {
                                this.sortDir = 'asc';
                        }
                        this.sort = s;
                },

                isActiveSort: function(s) {
                        return this.sort === s;
                },

                setPage: function(pageNumber) {
                        this.currentPage = pageNumber
                        // this.paginateFunc();
                        this.buildPageNavigationInfo()
                },

                setResultCount: function(count)
                {
                        this.resultCount = count
                },

                setCurrentPage: function(currentPage)
                {
                        this.currentPage = currentPage;
                },

                setInspectorViewList: function(list)
                {
                        this.pageDumpinpectorviewlist = list;
                },

                // SearchFilter: function()
                // {
                //         console.log(this.searchKey);
                //         this.searchText = this.searchKey;
                //         this.setPage(1);
                // },

                buildPageNavigationInfo() {

                        let _total = this.totalPages;
                        let _current = this.currentPage;

                        let firstPage = Math.max(1, _current - this.pageRange);
                        let lastPage = Math.min(_total, _current + this.pageRange);

                        this.pageNavigationInfo = {
                                start: firstPage-1,
                                end: lastPage,
                                hasFirstPageNavigation: firstPage > 1,
                                hasLastPageNavigation: lastPage < _total,
                                pageCount: lastPage - firstPage + 1,
                                total : _total,
                        }
                },



        },

        computed : {
                ...mapState("efb",["inpectorviewlist","deviceslistByuuid","heartbeatsignalsByuuid"]),

                // searchInspectorViewList: function()
                // {
                //        return this.inpectorviewlist.filter((post) => {
                //                 return post.devicE_UUID.match(this.searchText.toUpperCase()) ||
                //                         post.tlcLastLoggedIn.match(this.searchText.toUpperCase());})
                //
                //                 /*
                //                 *
                //                 */
                // },

                searchInspectorViewListSorted: function()
                {
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        return this.inpectorviewlist.sort((a, b) => {
                                let dir = (this.sortDir === 'asc') ? 1 : -1;
                                if (a[this.sort] < b[this.sort]) {
                                        return -1 * dir;
                                } else if (a[this.sort] > b[this.sort]) {
                                        return  1 * dir;
                                } else {
                                        return 0;
                                }
                        }).filter((post) => {
                                return post.devicE_UUID.match(this.searchText.toUpperCase()) ||
                                       post.tlcLastLoggedIn.match(this.searchText.toUpperCase()); })

                },

                totalPages: function() {
                        return Math.ceil(this.resultCount / this.itemsPerPage)
                },

                paginate: function() { // burada inspectorviewlist olması gerekmektedir.



                    if (!this.inpectorviewlist || this.inpectorviewlist.length != this.inpectorviewlist.length) {
                                return
                        }

                        this.setInspectorViewList(this.inpectorviewlist);

                        let list =  this.pageDumpinpectorviewlist.filter((post) => {
                            return post.devicE_UUID.match(this.searchText.toUpperCase()) ||
                                   post.tlcLastLoggedIn.match(this.searchText.toUpperCase()); })

                        //list = list

                        // var list = this.pageDumpinpectorviewlist.filter((post) =>{
                        //         return post.devicE_UUID.match(this.searchText.toUpperCase()) ||
                        //                 post.tlcLastLoggedIn.match(this.searchText.toUpperCase()); })
                        // console.log(list.length);

                        this.setResultCount(list.length);


                        if (this.currentPage >= this.totalPages)
                        {
                                this.setCurrentPage(this.totalPages);
                        }

                        var index = this.currentPage * this.itemsPerPage - this.itemsPerPage
                        // index= 0;


                        this.buildPageNavigationInfo();
                        return list.slice(index, index + this.itemsPerPage)
                                .sort((a, b) => {
                                let dir = (this.sortDir === 'asc') ? 1 : -1;
                                if (a[this.sort] < b[this.sort]) {
                                        return -1 * dir;
                                } else if (a[this.sort] > b[this.sort]) {
                                        return  1 * dir;
                                } else {
                                        return 0;
                                }
                        });


                },




                // searchSceduleFlights: function ()
                // {
                //         return this.flightList
                //                 .filter((post) => {
                //                         return post.carrier.match(this.searchText.toUpperCase())
                //                                 || post.adep.match(this.searchText.toUpperCase())
                //                                 || post.aarr.match(this.searchText.toUpperCase())
                //                                 || post.acreg.match(this.searchText.toUpperCase())
                //                                 || post.fno.match(this.searchText.toUpperCase())
                //                                 // || post.callsign.match(this.searchText.toUpperCase())
                //                                 || post.cP1.match(this.searchText.toUpperCase())
                //                                 || post.cP2.match(this.searchText.toUpperCase())
                //                                 || post.cP3.match(this.searchText.toUpperCase())
                //                                 ;}).sort((a, b) => (a.std > b.std) ? 1 : -1)//.sort((a, b) => new Date(a.std) - new Date(b.std)
                // },
        }

    }

</script>
<style scoped lang="scss">

        th {
                padding: 2.0rem 1.0rem;
                text-align: left;
                cursor: pointer;
                user-select: none;
                transition: all 0.3s ease;

                &.sorted {color: #f04 ;}
        }

        .progressfix{
                margin-bottom: 3px !important;
        }

        .fontsizesmall{
                font-size: 12px;
        }

        .user-table thead th {
                color: white;
                &.sorted {color: #f04 ;}
                background-color: #6a85a7;
                font-style: normal;
                font-size: 17px;
                top: -12px;
                position: sticky;
                z-index: 2;
        }

        .create-button {
                background-color: #6a85a7;
                color: white;
                font-size: 10px;
                font-size: 1.1rem;
                min-height: auto;
        }

        .user-table td {
                border: 0px;
        }

        .user-table {
                overflow-y: scroll;
                height: 670px;
        }

        .user-table th {
                top: -12px;
                position: sticky;
                background-color: white;
                z-index: 2;
        }

        .user-menu {
                background-color: #fff;
                /*border-radius: 6px;*/
                box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);
                color: #4a4a4a;
                display: block;
                padding: 1.25rem;
                margin-bottom: 5px;
                margin-top: 5px;
        }

        .role-selected {
                border: 0;
                cursor: pointer;
                font-size: 1em;
                font-family: Arial;
                position: relative;
        }

        .role-selected option {
                background-color: #6a85a7;
                color: white;
                font-family: sans-serif;
                font-style: unset;
                top: 100%;
                left: 0;
                right: 0;
                z-index: 99;
                position: absolute;
        }

        ::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
                background-color: #F5F5F5;
        }

        ::-webkit-scrollbar {
                height: 2px;
                width: 8px;
                background-color: #F5F5F5;
        }

        ::-webkit-scrollbar-thumb {
                background-color: #6a85a7;
        }

        .tooltip {
            position: relative;
            display: inline-block;
        }

        .tooltip .tooltiptext {
            visibility: hidden;
            min-width: 400px;
            max-width: 420px;
            background-color: #6a85a7de;
            border:3px solid;
            border-color: #4f4f4f;
            color: #fff;
            border-radius: 6px;
            top: 100%;
            left: 50%;
            margin-left: -366px;
            padding: 10px;
            margin-right: 23px;
            margin-top: 13px;
            font-size: 15px;
            text-align: left;

            /* Position the tooltip */
            position: absolute;
            z-index: 1111;
        }

        .tooltip:hover .tooltiptext {
            visibility: visible;
        }


</style>
